export default __webpack_public_path__ + "c071d41c8fc3b68d7381f998c53dc609.wav";